import React, { createContext, useContext, useState, useEffect } from 'react';
import fr from '../i18n/fr';
import ar from '../i18n/ar';

const translations = { fr, ar };

const LangContext = createContext({
  lang: 'fr',
  setLang: () => {},
  t: (key) => key,
  isRTL: false,
  dir: 'ltr',
});

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(
    () => localStorage.getItem('9achna_lang') || 'fr'
  );

  const setLang = (newLang) => {
    localStorage.setItem('9achna_lang', newLang);
    setLangState(newLang);
  };

  const isRTL = lang === 'ar';
  const dir = isRTL ? 'rtl' : 'ltr';

  useEffect(() => {
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', lang);
  }, [lang, dir]);

  // Falls back to French if key missing in Arabic
  const t = (key) =>
    translations[lang]?.[key] ?? translations['fr'][key] ?? key;

  return (
    <LangContext.Provider value={{ lang, setLang, t, isRTL, dir }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
